<template>
  <main-panel>
    <template slot="main-panel-content">
      <div class="p-4 width-100">
        <h2 class="mb-4">
          Home
        </h2>
        <h5>Please start by selecting which site you would like to edit.</h5>

        <div class="mt-4 d-flex align-items-center justify-content-start">
          <div
            class="app-card"
            @click="handleGlobalButtonClick"
          >
            <i class="fas fa-globe fa-3x" />
            <div class="ml-3 app-font">
              Global Care
            </div>
          </div>
          <div
            class="ml-4 app-card"
            @click="handlePaymentsButtonClick"
          >
            <i class="fas fa-credit-card fa-3x" />
            <div class="ml-3 app-font">
              Payments
            </div>
          </div>
        </div>
      </div>
    </template>
  </main-panel>
</template>

<script>
import AmplifyStore from '@/store/index'
import MainPanel from '@/components/Layout/MainPanel'

export default {
  name: 'Home',
  components: {
    MainPanel
  },
  data() {
    return {
      msg: 'Hello'
    }
  },
  computed: {
    user() {
      return AmplifyStore.state.auth.user
    }
  },
  methods: {
    handleGlobalButtonClick() {
      // TODO
    },
    handlePaymentsButtonClick() {
      this.$router.push({ name: 'client' })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~@/assets/styles/main.scss';
</style>
